import { Reveal } from "../../components/Reveal";
import { PageHero, CtaBand } from "../../components/ui";
import { DIFFERENCE_CARDS } from "../../data/site";

export default function Difference() {
    return (
        <>
            <PageHero
                eyebrow="Company — What Makes AddiGen Different"
                lines={["Infrastructure judgement,", "applied with discipline."]}
                trail={[{ label: "Home", path: "/" }, { label: "Company" }, { label: "What Makes AddiGen Different" }]}
            />
            <section className="bg-paper">
                <div className="container-x py-20 sm:py-24 lg:py-28">
                    <div className="grid gap-px overflow-hidden border border-line bg-line sm:grid-cols-2 lg:grid-cols-3">
                        {DIFFERENCE_CARDS.map((c, i) => (
                            <div key={c.n} className="bg-paper">
                                <Reveal delay={(i % 3) * 0.08} className="h-full">
                                    <article className="flex h-full flex-col bg-white p-8 transition-colors duration-300 hover:bg-mist sm:p-10" data-testid={`difference-card-${c.n}`}>
                                        <span className="font-mono text-[11px] tracking-[0.2em] text-blue">{c.n}</span>
                                        <h3 className="h3-compact mt-16 flex-1">{c.title}</h3>
                                        <p className="body-sm mt-6">{c.body}</p>
                                    </article>
                                </Reveal>
                            </div>
                        ))}
                    </div>
                    <Reveal delay={0.1}>
                        <p className="body-sm mt-8 max-w-2xl">
                            AddiGen applies CAES and BESS technologies based on duration, grid need
                            and market requirements — a system-led approach rather than a
                            technology-first one.
                        </p>
                    </Reveal>
                </div>
            </section>
            <CtaBand />
        </>
    );
}
